import History from "./history";
import Interactable from "./interactable";

export function moveGroupForward($element) {
    const $page = $element.parents('.page');
    const $group = $element.parents('[data-component="group"]');
    if ($group.length > 0) $element = $group;
    const $prev = $element.prev();

    function redo() {
        $element.remove();
        $page.children('.content').append($element);
    }

    function undo() {
        if ($prev.length > 0) {
            $prev.after($element);
        } else {
            $page.children('.content').prepend($element);
        }
    }

    redo();
    History.push(undo, redo, 'Move group to foreground');
}

export function moveGroupBack($element) {
    const $page = $element.parents('.page');
    const $group = $element.parents('[data-component="group"]');
    if ($group.length > 0) $element = $group;
    const $prev = $element.prev();

    function redo() {
        $element.remove();
        $page.children('.content').prepend($element);
    }

    function undo() {
        if ($prev.length > 0) {
            $prev.after($element);
        } else {
            $page.children('.content').prepend($element);
        }
    }

    redo();
    History.push(undo, redo, 'Move group in foreground');
}

export function moveToFront($element) {
    let $parent = $element.parents('.page').children('.content');
    const $group = $element.parents('[data-component="group"]');
    if ($group.length > 0) $parent = $group;
    const $prev = $element.prev();

    function redo() {
        $element.remove();
        $parent.append($element);
        Interactable.of($element).recreateInstance();
    }

    function undo() {
        if ($prev.length > 0) {
            $prev.after($element);
        } else {
            $parent.prepend($element);
        }
        Interactable.of($element).recreateInstance();
    }

    redo();
    History.push(undo, redo, 'Move to foreground');
}

export function moveToBack ($element) {
    let $parent = $element.parents('.page').children('.content');
    const $group = $element.parents('[data-component="group"]');
    if ($group.length > 0) $parent = $group;
    const $prev = $element.prev();

    function redo() {
        $element.remove();
        $parent.prepend($element);
        Interactable.of($element).recreateInstance();
    }

    function undo() {
        if ($prev.length > 0) {
            $prev.after($element);
        } else {
            $parent.prepend($element);
        }
        Interactable.of($element).recreateInstance();
    }

    redo();
    History.push(undo, redo, 'Move to foreground');
}

export function moveForward($element) {
    let $parent = $element.parents('.page').children('.content');
    const $group = $element.parents('[data-component="group"]');
    if ($group.length > 0) $parent = $group;
    const $next = $element.next();

    function redo() {
        $element.remove();

        if ($next.length > 0) {
            $next.after($element);
        } else {
            $parent.append($element);
        }
        Interactable.of($element).recreateInstance();
    }

    function undo() {
        if ($next.length > 0) {
            $next.before($element);
        } else {
            $parent.prepend($element);
        }
        Interactable.of($element).recreateInstance();
    }

    redo();
    History.push(undo, redo, 'Move to foreground');
}

export function moveBackward($element) {
    let $parent = $element.parents('.page').children('.content');
    const $group = $element.parents('[data-component="group"]');
    if ($group.length > 0) $parent = $group;
    const $prev = $element.prev();

    function redo() {
        $element.remove();

        if ($prev.length > 0) {
            $prev.before($element);
        } else {
            $parent.prepend($element);
        }
        Interactable.of($element).recreateInstance();
    }

    function undo() {
        if ($prev.length > 0) {
            $prev.after($element);
        } else {
            $parent.prepend($element);
        }
        Interactable.of($element).recreateInstance();
    }

    redo();
    History.push(undo, redo, 'Move in background');
}
